// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1D1zi","questions":"styles_questions__17J7D","footer":"styles_footer__1PMu-"};